import React, {Component} from 'react';
import topBar from '../modules/topBar';
import navbar from '../modules/navbar';
import report from '../modules/report';

class ReportPageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
  }

  render() {
  	return (
	    <div id="page-report">
        <topBar.container/>
        <div className="bottom-container">
          <navbar.container/>
          <div className="main-section">
            <report.container />
          </div>
        </div>
	    </div>
	  )
  }
}

export default ReportPageComponent;
